export default __webpack_public_path__ + "static/media/header-2.51e9c9c7.jpg";